import { gql } from "@apollo/client";

export const GET_RESULTADOS_SELECCION = gql`
query GetResultadosSeleccion {
    resultadosSeleccion {
        idResultadoSeleccion
        descripcion
    }
}`;

export const adaptResultadoSeleccionArray = (resultadosSeleccion) => {
  return resultadosSeleccion?.resultadosSeleccion.map((resultado) => ({
    id: resultado.idResultadoSeleccion,
    displayName: resultado.descripcion
  }));
};